<template>
  <div class="page">
    <MainHeader v-bind:page="'Talentenspel'"></MainHeader>
    <div class="container">
      <div class="row">
        <div class="whole component">
          <img :src="headerImage" width="938px" />
          <h1>Talentenspel</h1>
          <p class="highlight">
            Het Talentenspel is een instrument dat ontwikkeld is door Willem
            Glaudemans. Om met deze methode te kunnen werken heb ik de opleiding
            tot Talentencoach gevolgd en ben opgeleid tot gecertificeerd coach
            en trainer Talentenspel met alle borden. Door de specifieke
            speelwijze is het een uniek instrument om tot bewustwording te
            komen.
          </p>

          <p class="highlight">
            Het Talentenspel is een archetypisch spel waarbij gebruik wordt
            gemaakt van verschillende borden elk met zijn eigen unieke
            werkwijze. Vanuit de metafoor van de koets met paarden gaan we
            innerlijk op reis door deze borden. In de koets huist de ziel, op de
            koets zit de majesteit en voor de koets lopen de paarden. De paarden
            vertegenwoordigen de talenten. Deze reis, het Pad van de Held, neemt
            de speler mee door het innerlijk Koninkrijk, wakkert zijn natuurlijk
            leiderschap aan en geeft inzicht in het totale talententeam.
          </p>
          <p class="highlight">
            Het Talentenspel is een archetypisch spel waarbij gebruikt wordt
            gemaakt van verschillende borden en de talenten.
          </p>

          <p class="highlight">
            Ik ben opgeleid tot gecertificeerd coach en trainer met alle borden
            van het Talentenspel. Voor meer informatie over het Talentenspel
            kunt u terecht bij
            <a href="https://www.talentenspel.nl/">www.talentenspel.nl</a>
          </p>
          <p class="highlight">
            Wilt u informatie over begeleiding met het Talentenspel neem dan
            <router-link to="/contact">contact</router-link> met mij op.
          </p>
          <p class="highlight">
            <b
              >Heb jij het Talentenspel al een keer gespeeld? Dan is er nu een
              mogelijkheid om het Talentenspel als traject te volgen door alle
              acht borden, gegeven door Willem Glaudemans en Marjon te Riele.
              <a
                target="_blank"
                href="https://www.herbergvanhethart.eu/talentenspel-8-daagse.pdf"
                >Hierbij de volledige uitnodiging</a
              ></b
            >
          </p>
          <iframe
            src="https://www.herbergvanhethart.eu/imageslidermaker/example.html"
            style="display: block;height: 410px; width: 810px; padding: 0;margin: auto;border: 0;"
          ></iframe>
        </div>
      </div>

      <div class="row">
        <div class="whole component">
          <h2>Korte beschrijving van de borden</h2>
          <p>
            Om je inzicht te geven in de reis die je kunt maken binnen het
            Talentenspel worden de borden hieronder in het kort beschreven. De
            borden kunnen door elkaar gebruikt worden.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="half component">
          <img :src="nautilusBord" class="gameboard" />
          <h2>1. Het Nautilusbord</h2>
          <p>
            Het innerlijk kind en het natuurlijke groeiproces van iemands leven
            wordt hierin duidelijk. Hoe ontwikkelen de talenten zich en hoe
            ontwikkeld het jonge kind zich tot jong volwassene? Welke
            begeleiders spelen een rol en hoe kom je tot een eigen keuze voor
            opleiding of beroep?
          </p>
        </div>
        <div class="half component">
          <img :src="jongPiramideBord" class="gameboard" />
          <h2>2. Jong Piramidebord</h2>
          <p>
            Richting in het leven van de jongeren die op zijn pad naar
            volwassenheid het oude achter zich laat en zelf op pad gaat om zijn
            droomwens te verwezenlijken.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="half component">
          <img :src="wereldBord" class="gameboard" />
          <h2>3. Het Wereldbord</h2>
          <p>
            Harmonisatie en integratie. Het spelen van dit bord zorgt vooral
            voor innerlijke schoonmaak. Vervorming van talenten worden
            opgespoord en gezond gemaakt. De positie van de Koning(in) wordt
            verhelderd en bekrachtigd.
          </p>
        </div>
        <div class="half component">
          <img :src="levensboomBord" class="gameboard" />
          <h2>4. Het Levensboombord</h2>
          <p>
            Inzicht in richting en hiërarchie. Het spelen van dit bord zorgt
            vooral voor uitzicht op de richting van het leven. Je krijgt inzicht
            op je pad en je doel ofwel je missie, en richtingsgevoel.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="half component">
          <img :src="piramideBord" class="gameboard" />
          <h2>5. Het Piramidebord</h2>
          <p>
            Manifestatie en Creatie. Het spelen van dit bord voegt een volgende
            fase toe aan het proces. Dit bord brengt de missie op aarde, het
            bord van incarnatie, concrete manifestatie van de missie in het
            dagelijkse leven.
          </p>
        </div>
        <div class="half component">
          <img :src="zielespiegelBord" class="gameboard" />
          <h2>6. Het Zielespiegelbord</h2>
          <p>
            Instrumentatie en zelfrealisatie. Het spelen van dit bord brengt de
            verschillende innerlijke niveaus van de mens bijeen. Men gaat
            ontdekken dat de missie niet vanuit een drang tot doen kan worden
            vormgegeven, maar alleen als een spontane uitdrukking van 'zijn'.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="half component">
          <img :src="bordVanEenheid" class="gameboard" />
          <h2>7. Bord van Eenheid</h2>
          <p>
            Thuis en Eenheid, Ervaring van Thuis komen. Alles komt samen. Zo
            ziet Eenheid vanuit mijn ziel en vanuit mijn missie in totale Liefde
            eruit. Dit bord kan alleen met het Zielespiegelbord samen ervaren
            worden om de eenheid tussen jou en God te ervaren.
          </p>
        </div>
        <div class="half component">
          <img :src="bordVanCreatie" class="gameboard" />
          <h2>8. Bord van Creatie</h2>
          <p>Wat is creatie en scheppen en hoe werkt dit voor jou.</p>
        </div>
      </div>
    </div>
    <MainFooter
      style="display:flex; margin-left: auto; margin-right:auto;"
    ></MainFooter>
  </div>
</template>

<script>
import MainHeader from "../MainHeader";
import MainFooter from "../MainFooter";

export default {
  name: "Talentenspel",
  data() {
    return {
      headerImage: require("../../img/talentenspel.jpg"),
      nautilusBord: require("../../img/nautilusbord_nl.jpg"),
      jongPiramideBord: require("../../img/jongpiramidebord_nl.jpg"),
      wereldBord: require("../../img/wereldbord_nl.jpg"),
      levensboomBord: require("../../img/levensboombord_nl.jpg"),
      piramideBord: require("../../img/piramidebord_nl.jpg"),
      zielespiegelBord: require("../../img/zielespiegelbord_nl.jpg"),
      bordVanEenheid: require("../../img/bordvaneenheid_nl.jpg"),
      bordVanCreatie: require("../../img/bordvancreatie_nl.jpg"),
      bordVanMajesteit: require("../../img/bord_majesteit_3.jpg"),
      bordVanMajesteit2: require("../../img/bord_majesteit_2.jpg")
    };
  },
  computed: {},
  methods: {},
  components: {
    MainHeader,
    MainFooter
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Talentenspel.vue